import { RadioGroupPelican } from './component';

export * from './component';

export default RadioGroupPelican;
